<sm-tab-view class="document-object-tabs flex-item-fill height100p width100p full-height direct-sub" [class.tab-view-no-pad]="app.isMobile()" [class.compact]="app.isMobile()">
    @if (showDocument) {
        <sm-tab value="0" [header]="app.t('general.preview')">
            @if (!_Utils.isNoe(_remarkObjects)) {
            <p-select class="width100p mb-2" [options]="_remarkObjects" [(ngModel)]="selectedRemarkObjectToken" (ngModelChange)="updateData()"></p-select>
            }
            @if (loading) {
                <div class="preview-state">
                    <p-progressSpinner></p-progressSpinner>
                </div>
            }
            @else if (!_Utils.isNoe(loadError)) {
                <div class="preview-state p-4 text-center">
                    <i class="fas fa-triangle-exclamation preview-error-icon"></i>
                    <div>{{loadError}}</div>
                    <button pButton icon="fas fa-redo-alt" [label]="app.t('general.buttons.retry')" (click)="retryLoad()"></button>
                </div>
            }
            @else {
                <app-pdf-viewer class="height100p width100p" [src]="pdfSrc" zoom="page-width" preset="viewer" (documentLoaded)="previewLoaded()" (documentLoadFailed)="previewLoadFailed()"></app-pdf-viewer>
            }
        </sm-tab>
    }
    @if (showMetaData) {
        <sm-tab [value]="showDocument ? '1' : '0'" [header]="app.t('enaio.indexData')">
            @if (table != null) {
                <sm-table class="height100p" [data]="table" [compact]="app.isMobile()" [autoRowHeight]=true [floatingFilter]="!app.isMobile()"></sm-table>
            }
        </sm-tab>
    }
</sm-tab-view>
